<template>
  <div class="view-box">
    <div class="title-box">
      <div class="title">
        <p class="title2">华北地区降水落区预报</p>
      </div>
      <div class="map-title-box">
        <span :class="tabcss1?'xzcss':'wxzcss'" @click="Btn1(1)">{{ pie }}</span>
        <span :class="tabcss2?'xzcss':'wxzcss'" @click="Btn1(2)">{{ pis }}</span>
        <span @click="Btn1(3)" :class="tabcss3?'xzcss':'wxzcss'">{{ pid }}</span>
      </div>
      <div class="table-box">
        <img id="hb" v-show="hasPic" :src="picturee" alt="无预警"
             style=" cursor:hand; width:60%;text-align: center;margin:0 20%">
        <div class="imgg" v-show="!hasPic">
          <i>当前时次无产品</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasPic: true,
      picturee: [],
      radio: 1, //单选按钮的值
      picture: "",
      pie: [],
      pis: [],
      pid: [],
      piv: "",
      pic: "",
      tabcss1: true,
      tabcss2: false,
      tabcss3: false
    };
  },
  created: function () {
    this.getTP();
  },

  methods: {
    Btn1(radio) {
      this.radio = radio;
      this.hasPic = true;
      if (this.radio == "1") {
        this.tabcss1 = true;
        this.tabcss2 = false;
        this.tabcss3 = false;
        if (this.picture === '') {
          this.hasPic = false;
        } else {
          this.picturee = this.picture
        }
      } else if (this.radio == "2") {
        this.tabcss1 = false;
        this.tabcss2 = true;
        this.tabcss3 = false;
        if (this.piv === '') {
          this.hasPic = false;
        } else {
          this.picturee = this.piv
        }
      } else {
        this.tabcss1 = false;
        this.tabcss2 = false;
        this.tabcss3 = true;
        if (this.pic === '') {
          this.hasPic = false;
        } else {
          this.picturee = this.pic
        }
      }
    },

    getTP: function () {
      this.$post("RainArea_bj.action")
          .then(body => {

            var pict = body.Result;
            this.picture = pict[0].url;
            if (this.picture === '') {
              this.hasPic = false;
            } else {
              this.picturee = this.picture;
            }

            this.piv = pict[1].url;
            this.pic = pict[2].url;

            var TimeS = body.times;
            this.pie = TimeS.split(",")[0];
            this.pis = TimeS.split(",")[1];
            this.pid = TimeS.split(",")[2];
          })
          .catch(error => {
            this.hasPic = false;
            console.log(error);
          });
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
$height = 30px;
.view-box {
  width: 1000px;
  height: 100%;
  margin: 0 auto;
  padding: 0;

  .title-box {
    height: 100%;
    padding: 6px 6px;

    .title {
      width: 100%;
      height: $height;
      background: #f8f8f8;
      line-height: $height;
      background: #f8f8f8;
      line-height: $height;
      display: flex;
      background: #4595e6;
      color: #ffffff;
      border-top-left-radius: 5px;
      -moz-border-top-left-radius: 5px;
      -webkit-border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      -moz-border-top-right-radius: 5px;
      -webkit-border-top-right-radius: 5px;
      /* border: 1px solid #d6d6d6;*/

      span {
        cursor: pointer;

        img {
          widows: 20%;
          height: 20px;
          margin: 6px;
        }
      }

      .title2 {
        height: $height;
        line-height: $height;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        position: relative;
        padding: 0 12px;
        width: 100%;
      }
    }

    .map-title-box {
      display: flex;
      line-height: $height;
      border-left 1px solid #eee
      border-right 1px solid #eee

      .xzcss {
        display: inline-block;
        width: 50px;
        text-align: center;
        font-size: 14px;
        line-height: 50px;
        // background-color: #1f6c5a;
        color: red;
        padding: 0 6px;
        font-weight: bold;
        text-decoration: underline;
        cursor: pointer;
      }

      .wxzcss {
        display: inline-block;
        width: 50px;
        color: #003464;
        text-align: center;
        font-size: 14px;
        line-height: 50px;
        padding: 0 6px;
        font-weight: bold;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .table-box {
      width: 100%;
      height: 30%;
      position: relative;
      border-left 1px solid #eee
      border-right 1px solid #eee
      border-bottom 1px solid #eee

      img {
        width: 100%;
        height: auto;
      }
    }
  }
}

.imgg {
  width: 100%;
  height: 100%

  i {
    display inline-block
    width 100%
    font 400 20px / 300px "microsoft yahei"
    text-align center
  }
}
</style>
